import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubscriptionCheckoutModel } from 'src/app/models/subscriptionCheckout.model';
import { PlanGroupModel } from 'src/app/models/planGroup.model';
import { SubscriptionListModel } from 'src/app/models/subscriptionList.model';
import { PlanModel } from 'src/app/models/plan.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  private serviceUrlPlan = environment.apiUrl + 'plan';
  private serviceUrl = environment.apiUrl + 'subscription';

  constructor(private http: HttpClient) { }

  getPlansByModule(id: string): Observable<PlanGroupModel[]> {
    return this.http.get<PlanGroupModel[]>(`${this.serviceUrlPlan}/getPlansByModule/${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getSubscriptionSession(id: string): Observable<string> {
    return this.http.get<string>(`${this.serviceUrl}/getSubscriptionCheckoutSession/${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

    upsertUserSubscriptions(): Observable<string> {
    return this.http.get<string>(`${this.serviceUrl}/upsertUserSubscriptions`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getMySubscriptions(): Observable<SubscriptionListModel[]> {
    return this.http.get<SubscriptionListModel[]>(`${this.serviceUrl}/getMySubscriptions`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getSubscriptionCheckout(id: string): Observable<SubscriptionCheckoutModel> {
    return this.http.get<SubscriptionCheckoutModel>(`${this.serviceUrl}/getSubscriptionCheckout/${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  setSubscription(newSub: SubscriptionCheckoutModel): Observable<SubscriptionCheckoutModel> {
    return this.http.post<SubscriptionCheckoutModel>(`${this.serviceUrl}/setSubscription`, newSub, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getCustomerPortalSession(): Observable<any> {
    return this.http.get<any>(`${this.serviceUrl}/getCustomerPortalSession`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }
} 
